module.exports = __webpack_public_path__ + "static/media/download-apk-mobile-qrcode.1c1e6410.png";